import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { IoIosArrowDown as ArrowDown } from "react-icons/io";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown";
import FilterSearchSection from "../../../components/FilterComponents/FilterSearchSection";
import OptionalOption from "../../../components/FilterComponents/OptionalOption";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import { activityOptions, selectedOption } from "../../../utils/options";
import { handleDropdownClose } from "../../../utils/utils";


const LogsFilterData = ({ isSidebarOpen, filterData, onSetFilterData }) => {
    const [contactData, setContactData] = useState([]);
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);
    const [config] = useAuth();
    const [loading, setLoading] = useState(false);
    const [userOptions, setUserOptions] = useState([]);

    const fetchUsers = () => {
        setLoading(true);
        axios
            .get(`${BASE_URL}/get-datalisting?list=users`, config)
            .then((res) => {
                const data = res?.data?.data;
                const options = data?.map((el) => ({ value: el?.id, label: `${el?.first_name} ${el?.last_name}`, role: el?.role_id }));
                setUserOptions(options);
            })
            .catch((err) => {
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message);
                }
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (isSidebarOpen) {
            fetchUsers();
        }
    }, [isSidebarOpen]);

    const handleFilterChange = (value, name) => {
        onSetFilterData({ ...filterData, [name]: value });
    };

    const fetchSuggestions = (inputValue) => {
        axios
            .get(`${BASE_URL}/get-datalisting?list=contacts&search=${inputValue}`, config)
            .then((res) => {
                const data = res.data.data.contact_list;
                const options = data.map((contact) => ({ value: contact.id, label: `${contact.first_name} ${contact.last_name}` }));
                setContactData(options);
            })
            .catch((err) => {
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message);
                }
            });
    };

    useEffect(() => {
        const handleClose = () => {
            setIsOpen(false);
        };
        handleDropdownClose(dropdownRef, handleClose);
    }, []);



    return (
        <>
            <div>
                <p className="head-4 dark-H capitalize">Date</p>

                <OptionalOption
                    activeTab="date"
                    onSetLastDate={(value) => handleFilterChange(value, "activity_count")}
                    date={filterData?.activity_count}
                    onSetDateRange1={(value) => {
                        handleFilterChange(value, "activity_start_count");
                    }}
                    date2={filterData?.activity_start_count}
                    onSetDateRange2={(value) => handleFilterChange(value, "activity_end_count")}
                    date3={filterData?.activity_end_count}
                    onClear={() => {
                        onSetFilterData({ ...filterData, activity_count: "", activity_start_count: "", activity_end_count: "" });
                    }}
                />
            </div>

            <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

            <div className="mt-4">
                <label className="dark-H head-4 mb-2">
                    User Name
                </label>
                <Select
                    ref={selectRef}
                    className="body-N"
                    options={userOptions}
                    placeholder="Select"
                    value={userOptions.find((option) => option?.value === filterData?.interaction_type_user) || null}
                    onChange={(option) => handleFilterChange(option?.value, "interaction_type_user")}
                />
            </div>

            <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />


            <div className="search-box w-[100%] mt-2">
                <label className="dark-H head-4 mb-2">
                    Module
                </label>
                <Select
                    className="body-N"
                    options={selectedOption}
                    placeholder="Select"
                    value={selectedOption.find((option) => option?.value === filterData?.module) || null}
                    onChange={(option) => handleFilterChange(option?.value, "module")}
                />
            </div>

            <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

            <div>
                <p className="head-4 dark-H">Contact</p>

                <div className="mt-2">
                    <SearchDropdown
                        isTop={false}
                        placeholder={`Search contact`}
                        text={filterData?.contact?.name}
                        options={contactData}
                        fetchSuggestions={fetchSuggestions}
                        onSetOptions={(value) => setContactData(value)}
                        handleSelect={(option) => {
                            onSetFilterData({
                                ...filterData,
                                contact: { id: option?.value, name: option?.label },
                            });
                            setContactData([]);
                        }}
                    />
                </div>
            </div>

             <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

            <div className="">
                <FilterSearchSection
                    type="text"
                    title="Description"
                    placeholder="write here"
                    value={filterData?.description}
                    onChange={(e) => {
                        handleFilterChange(e.target.value, "description");
                    }}
                />
            </div>

            <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

            <div className="mt-4">
                <p className="head-4 dark-H">Interaction Type</p>

                <div ref={dropdownRef} className="custom-dropdown mt-2">
                    <div
                        role="button"
                        className="select-header-input capitalize light-bg-L body-N dark-M flex justify-between items-center"
                        onClick={() => {
                            setIsOpen(!isOpen);
                        }}
                    >
                        {filterData.interaction_type === ""
                            ? "Select"
                            : (activityOptions.find((el) => el.value === filterData.interaction_type)?.label || "Select")
                        } <ArrowDown />
                    </div>
                    {isOpen && (
                        <div className="dropdown-list-container light-bg-L dark-M body-N shadow rounded-box" style={{ width: "100%" }}>
                            <ul className="dropdown-list">
                                {activityOptions.map((el, i) => (
                                    <li
                                        key={i}
                                        role="button"
                                        onClick={() => {
                                            handleFilterChange(el.value, "interaction_type");
                                            setIsOpen(false);
                                        }}
                                        className={`${filterData.interaction_type === el.value ? "active" : ""}`}
                                    >
                                        {el.label}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>

                <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />
            </div>

           
        </>
    )
}

export default LogsFilterData;